import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from 'axios';
import uploadFormDataToS3 from './uploadFormDataToS3';
function uploadFile(_x) {
  return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
  _uploadFile = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var file, referenceId, referenceIds, type, language, onProgress, skipPostProcessing, skipAssigningToReference, style, alternativeText, notifyOnProcessingCompletion, _yield$axios$post, _yield$axios$post$dat, policy, uploadToken, s3UploadResult, _yield$axios$post2, data, _error$data, formattedErrorMessage, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          file = _ref.file, referenceId = _ref.referenceId, referenceIds = _ref.referenceIds, type = _ref.type, language = _ref.language, onProgress = _ref.onProgress, skipPostProcessing = _ref.skipPostProcessing, skipAssigningToReference = _ref.skipAssigningToReference, style = _ref.style, alternativeText = _ref.alternativeText, notifyOnProcessingCompletion = _ref.notifyOnProcessingCompletion;
          _context.prev = 1;
          _context.next = 2;
          return axios.post('/api/files/policy', {
            filename: file.name,
            type: type,
            contentType: file.type,
            size: file.size,
            referenceId: referenceId,
            referenceIds: referenceIds,
            language: language,
            skipPostProcessing: skipPostProcessing,
            skipAssigningToReference: skipAssigningToReference,
            notifyOnProcessingCompletion: notifyOnProcessingCompletion,
            style: style,
            alternativeText: alternativeText
          });
        case 2:
          _yield$axios$post = _context.sent;
          _yield$axios$post$dat = _yield$axios$post.data;
          policy = _yield$axios$post$dat.policy;
          uploadToken = _yield$axios$post$dat.uploadToken;
          _context.next = 3;
          return uploadFormDataToS3({
            policy: policy,
            file: file,
            onProgress: onProgress
          });
        case 3:
          s3UploadResult = _context.sent;
          _context.next = 4;
          return axios.post('/api/files/new', {
            uploadToken: uploadToken
          });
        case 4:
          _yield$axios$post2 = _context.sent;
          data = _yield$axios$post2.data;
          return _context.abrupt("return", _objectSpread(_objectSpread({}, s3UploadResult), data));
        case 5:
          _context.prev = 5;
          _t = _context["catch"](1);
          formattedErrorMessage = ((_error$data = _t.data) === null || _error$data === void 0 ? void 0 : _error$data.error) || _t.message; // Try to use the error returned by the API
          _t.formattedErrorMessage = formattedErrorMessage;
          throw _t;
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _uploadFile.apply(this, arguments);
}
export default uploadFile;